import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function CEOMessage() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <div
      ref={ref}
      className={`${
        isVisible ? "" : ""
      } bg-white py-20 lg:py-6 xl:py-8 1xl:py-6 2xl:py-6 px-6 !pb-20 xxs:px-8 xs:px-10 sm:px-10 md:px-10 lg:px-16 xl:px-16 1xl:px-0 2xl:px-4 4xl:px-16`}
    >
      <div className="mx-auto space-y-8 lg:space-y-12 max-w-7xl" style={{ lineHeight: '1.2' }}>
        {/* Header */}
        <div className="flex flex-col items-start lg:items-center gap-6">
          <p className="text-[#757575] text-lg xxs:text-[15px] xs:text-[17px] sm:text-[17px] md:text-[18px] 4xl:text-[24px] lg:text-lg font-medium text-left lg:text-center enfinity-subtext-font">Message from the Founder</p>
          
          <h1 className="text-4xl xxs:text-[55px] lg:text-[80px] 4xl:text-[90px]  font-nromal text-black text-left lg:text-center leading-tight xxs:leading-[50px] xs:leading-[60px] sm:leading-[50px] md:leading-[60px] lg:leading-[70px] enfinity-header-font enfinity-header-font" style={{ lineHeight: '1.2' }}>
            "Helping creators earn more from what they've already made."
          </h1>
        </div>

        {/* Message Content */}
        <div className="space-y-6 lg:space-y-6 enfinity-subtext-font" style={{ lineHeight: '1.2' }}>
          <p className="text-[28px] xxs:text-[1rem] lg:text-[28px] 4xl:text-[28px] font-normal text-[#161616] leading-[39px] lg:leading-[35px] enfinity-subtext-font" style={{ lineHeight: '1.5' }}>
            I've been part of the Creator Economy since the early days... long before it had a name. I launched a YouTube channel back in 2011 making Minecraft videos, and I still remember the rush of passing my first 100 subscribers. That spark never left. Since then, I've had the privilege of founding multiple ventures in the space.
          </p>

          <p className="text-[28px] xxs:text-[1rem] lg:text-[28px] 4xl:text-[28px] font-normal text-[#161616] leading-[39px] lg:leading-[35px] enfinity-subtext-font" style={{ lineHeight: '1.5' }}>
            Today, Enfinity is a top-line $80M company supporting thousands of creators around the world. We also built CreatorShield, which is a YouTube Content ID powerhouse that helped creators recover millions in royalties into a $10M business in just two years before its strategic exit from the Enfinity Group in 2024.
          </p>

          <p className="text-[28px] xxs:text-[1rem] lg:text-[28px] 4xl:text-[28px] font-normal text-[#161616] leading-[39px] lg:leading-[35px] enfinity-subtext-font" style={{ lineHeight: '1.5' }}>
            Now, we're taking things even further. The Enfinity Ecosystem is our commitment to building tools that help creators earn more from what they've already made — unlocking new revenue streams with less effort, and protecting their content without compromise.
          </p>

          <p className="text-[28px] xxs:text-[1rem] lg:text-[28px] 4xl:text-[28px] font-normal text-[#161616] leading-[39px] lg:leading-[35px] enfinity-subtext-font" style={{ lineHeight: '1.5' }}>
            Behind the scenes, I'm just a dad and a husband, blessed with a loving wife and two beautiful young kids. We spend most of the year in South-East Asia, and I sneak in time on my motorbike whenever I can. I'm also a devoted Christian. My faith is a quiet foundation in both life and business.
          </p>

          <p className="text-[28px] xxs:text-[1rem] lg:text-[28px] 4xl:text-[28px] font-normal text-[#161616] leading-[39px] lg:leading-[35px] enfinity-subtext-font" style={{ lineHeight: '1.5' }}>
            I'm grateful you're here. And if you're building something you care about, I hope we can help you go further with it.
          </p>
        </div>

        {/* CEO Info */}
        <div className="flex flex-row items-center gap-3 xxs:gap-3 sm:gap-5 md:gap-6 lg:gap-[41px] mt-12 lg:mt-20">
          <div className="w-[70px] h-[70px] xxs:w-[70px] xxs:h-[70px] xs:w-[70px] xs:h-[70px] sm:w-[80px] sm:h-[80px] md:w-[100px] md:h-[100px] lg:w-[145px] lg:h-[145px] rounded-full overflow-hidden flex-shrink-0 enfinity-subtext-font">
            <img
              src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/ceo-pfp.jpg"
              alt="Jake William Jones"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex flex-col gap-1.5 xxs:gap-2 sm:gap-3 md:gap-4 items-start flex-1">
            <div className="flex items-center gap-2 sm:gap-3 md:gap-4 justify-start">
              <div className="h-[48px] xxs:h-[30px] xs:h-[40px]  sm:h-[45px]  md:h-[56px] lg:h-[60px] lg:w-[243px]">
                <img
                  src="https://cdn-vvv-e9hucnd2c4dye2ek.z01.azurefd.net/assets/enfinity/ceo-penmanship.png"
                  alt="CEO Penmanship"
                  className="w-full h-full object-contain mr-auto"
                />
              </div>
            </div>
            <div className="flex flex-col gap-1 lg:gap-2 items-start text-left">
              <p className="text-[18px] xxs:text-[10px] xs:text-[14px] sm:text-[14px] md:text-[20px] lg:text-2xl font-medium text-black leading-[28px] xxs:leading-[28px] xs:leading-[30px] sm:leading-[32px] md:leading-[34px] lg:leading-[34px]">
                Jake William Jones, Founder/CEO
              </p>
              <p className="text-[16px] xxs:text-[12px] xs:text-[15px] sm:text-[16px] md:text-[18px] lg:text-base font-normal text-[#757575] leading-[22px] xxs:leading-[22px] xs:leading-[23px] sm:leading-[24px] md:leading-[25px] lg:leading-[25px]">
                Enfinity Group of Companies
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
